"use client";
import Image from "@/components/Image/Image.component";
import { Typography } from "@/components/Typography/Typography.component";
import { cn } from "@/lib/utils";
import * as Accordion from "@radix-ui/react-accordion";
import { CustomAccordionPropsModel } from "./CustomAccordion.model";
const CustomAccordion = ({
  title,
  accordionItemsCollection,
}: CustomAccordionPropsModel) => {
  return (
    <div className="bg-core-white text-core-black z-20 px-4 py-10 md:px-8 lg:px-10">
      <div className="grid grid-cols-12">
        <Typography.LLABEL1 className="border-core-black col-span-10 col-start-2 border-b border-solid py-8 md:col-span-12">
          {title}
        </Typography.LLABEL1>
      </div>

      <Accordion.Root type="single" className="grid grid-cols-12" collapsible>
        {accordionItemsCollection.map((item, index) => {
          return (
            <Accordion.Item
              key={index}
              value={`item-${index}`}
              className={cn(
                "relative grid justify-between max-md:flex-wrap md:grid",
                "col-span-10 col-start-2 md:col-span-12",
                "border-core-black border-b border-solid",
              )}
            >
              <Accordion.Trigger
                className={cn(
                  "hover:text-core-blue flex justify-between overflow-hidden max-md:flex-wrap",
                  "col-span-12 py-8 md:col-span-12 md:gap-x-8 lg:gap-x-8",
                  "data-[state=open]:text-core-blue",
                )}
              >
                <Accordion.Header
                  className={cn(
                    "w-min flex-none shrink basis-1/2 md:w-min",
                    "order-1",
                    "text-left",
                  )}
                >
                  <Typography.H4>{item.title}</Typography.H4>
                </Accordion.Header>
                <Accordion.Content
                  className={cn(
                    "order-3 flex w-full flex-wrap overflow-hidden lg:w-[50%]",
                    "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down transition-all",
                    "gap-8",
                    "text-left !text-black",
                  )}
                >
                  {item?.image && (
                    <Image
                      src={`${item.image.url}?fm=webp`}
                      alt={item.title}
                      width={item.image.width || 0}
                      height={item.image.height || 0}
                      style={{ minHeight: `${item.image.height}px` }}
                      className={cn(
                        "h-fit w-screen object-cover md:max-w-[210px] lg:w-auto lg:max-w-[290px]",
                        "pt-8",
                      )}
                    />
                  )}
                  <Typography.BODY1 className={cn(!item?.image && "pt-8")}>
                    {item.copy}
                  </Typography.BODY1>
                </Accordion.Content>
                <Accordion.Header className="order-2 data-[state=open]:hidden">
                  <div>
                    <Typography.H4>[+]</Typography.H4>
                  </div>
                </Accordion.Header>
                <Accordion.Header className="order-2 data-[state=closed]:hidden">
                  <div>
                    <Typography.H4>[-]</Typography.H4>
                  </div>
                </Accordion.Header>
              </Accordion.Trigger>
            </Accordion.Item>
          );
        })}
      </Accordion.Root>
    </div>
  );
};

export default CustomAccordion;
